import { createContext, useContext } from 'react';
import { initialState } from './ProgrammedMessageAction.constants';
import { tProgrammedMessageActionContext } from './ProgrammedMessageAction.types';

export const ProgrammedMessageActionContext =
  createContext<tProgrammedMessageActionContext>(initialState);

export function useProgrammedMessageActionContext() {
  useContext(ProgrammedMessageActionContext);
}
